<template>
  <div>
    <span
      class="text-disabled"
      v-if="textForDisableAdmin"
    >{{ textForDisableAdmin }}
    </span>
    <div>
      <el-select
        class="admin-by-row-selector"
        :value="adminId"
        @input="handleChangeAdmin"
        filterable
        :disabled="disabled"
        clearable
        :placeholder="placeholderRow"
      >
        <el-option
          v-for="item in adminOptions"
          :key="item.adminId"
          :label="item.name"
          :value="item.adminId"
        >
          <div class="admin-option">
            <div class="name">{{ item.name }}</div>
          </div>
        </el-option>
      </el-select>
      
    </div>
  </div>
</template>

<script>
import { Select, Option } from "element-ui";
import axios from "axios";
import { existValueAndEmptyString } from "@/lib/util";

export default {
  components: {
    "el-select": Select,
    "el-option": Option
  },
  props: [
    "value",
    "disabled",
    "role",
    "placeholder",
    "textForDisableAdmin"
  ],
  data() {
    return {
      admins: []
    };
  },
  computed: {
    adminOptions() {
      return this.admins
    },
    adminId() {
      if (!this.value) {
        return null;
      }

      return this.value && this.value.adminId
        ? +this.value.adminId
        : +this.value;
    },
    placeholderRow() {
      if (this.placeholder && this.role) return `${this.placeholder} ${this.role}`;
      if (this.placeholder) return this.placeholder

      return this.role
        ? `${this.role}`
        : "All"
    }
  },
  created() {
    this.setup();
  },
  methods: {
    setup() {
      this.setupAdmins();
    },
    async setupAdmins() {
      const adminsByRole = await this.fetchAdmins();
      
      if (!adminsByRole) {
        return [];
      }
  
      this.admins = adminsByRole.map(admin => {
        const {
          admin_id,
          first_name,
          last_name,
          role_id
        } = admin;

        return {
          adminId: admin_id,
          name: `${first_name} ${last_name}`,
          roleId: role_id
        };
      });
    },
    async fetchAdmins() {
      const role = this.role || "Admin";

      const result = await axios.get(`${process.env.HOST}/admin/staffs/${role}/roles`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`
        }
      });

      return result.data;
    },
    handleChangeAdmin(adminId) {
      if (!adminId || !existValueAndEmptyString(adminId)) {
        this.$emit("input", null);
      }

      const admin = this.admins.find(
        admin => admin.adminId === adminId
      );

      this.$emit("input", admin && admin.adminId || null);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";

.admin-selector:hover + .hide {
  width: 100%;
  display: block;
  font-size: 14px;
}

.hide {
  display: none;
}

.admin-option {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
}

.admin-by-row-selector {
  width:300px
}

.text-disabled {
  font-size: 12px;
  color: gray;
}

</style>



// WEBPACK FOOTER //
// src/lib/components/AdminByRowSelector.vue